import About from "@/components/About"
import Collection from "@/components/Collection"
import Faq from "@/components/Faq"
import Footer from "@/components/Footer"
import GiftSet from "@/components/GiftSet"
import Header from "@/components/Header"
import Hero from "@/components/Hero"
import Lifestyle from "@/components/Lifestyle"
import OrderForm from "@/components/OrderForm"
import ProductDetail from "@/components/ProductDetail"
import Story from "@/components/Story"

function Home() {
  return (
    <main>
      <Header />
      <Hero />
      <Story />
      <Collection />
      <ProductDetail />
      <Lifestyle />
      <GiftSet />
      <OrderForm />
      <Faq />
      <About />
      <Footer />
    </main>
  )
}

export default Home
